// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-catalog-__slug-indexstyleGrid-container-xwytp{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-catalog-__slug-indexstyleGrid-grid-lhske{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-catalog-__slug-indexstyleGrid-col6-fdgxr{grid-column:span 6}.pages-catalog-__slug-indexstyleGrid-col3-bxecy{grid-column:span 3}.pages-catalog-__slug-indexstyleGrid-col4-wgbwt{grid-column:span 4}.pages-catalog-__slug-indexstyleGrid-col9-btokm{grid-column:span 9}.pages-catalog-__slug-indexstyleGrid-col12-bclci{grid-column:span 12}.pages-catalog-__slug-indexstyleGrid-alignItemsStart-qxhwa{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-catalog-__slug-indexstyleGrid-container-xwytp",
	"grid": "pages-catalog-__slug-indexstyleGrid-grid-lhske",
	"col6": "pages-catalog-__slug-indexstyleGrid-col6-fdgxr",
	"col3": "pages-catalog-__slug-indexstyleGrid-col3-bxecy",
	"col4": "pages-catalog-__slug-indexstyleGrid-col4-wgbwt",
	"col9": "pages-catalog-__slug-indexstyleGrid-col9-btokm",
	"col12": "pages-catalog-__slug-indexstyleGrid-col12-bclci",
	"alignItemsStart": "pages-catalog-__slug-indexstyleGrid-alignItemsStart-qxhwa"
};
module.exports = ___CSS_LOADER_EXPORT___;
